// components/FormContainer.js
import React from 'react';
import { Box, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const FormContainer = ({ children, sx = {} }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: 3,
                boxShadow: 2,
                borderRadius: 2,
                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? alpha(theme.palette.grey[900], 0.3)
                        : alpha('#ffffff', 0.3),
                ...sx, // allow additional overrides
            }}
        >
            {children}
        </Box>
    );
};

export default FormContainer;
